import { Injectable } from '@angular/core';
import { Sales } from 'tilby-models';

export interface HistoryDataMap {
  'sales-data-sent': Sales[];
}

export type HistoryDataSetKey = keyof HistoryDataMap;
export type HistoryDataSetValue = HistoryDataMap[HistoryDataSetKey];

@Injectable({
  providedIn: 'root'
})
export class HistoryDataCatalogService {

  private _historyDataCatalog = new Map<HistoryDataSetKey, HistoryDataSetValue>();

  get itemDataCatalog(): Map<HistoryDataSetKey, HistoryDataSetValue> {
    return this._historyDataCatalog;
  }


  addDataToCatalog(key: HistoryDataSetKey, value: HistoryDataSetValue): void {
    this._historyDataCatalog.set(key, value);
  }

  getDataByKey<K extends HistoryDataSetKey>(key: K): HistoryDataMap[K] | undefined {
    const originalArray =  this._historyDataCatalog.get(key);
    if (originalArray) {
      return structuredClone(originalArray) as HistoryDataMap[K];
    }
    return undefined;
  }
}
